import css_xzik5yp59l from './css/PlaylistContainer.css';
import Div from './Div.js';
import Playlist from './Playlist.js';

const css = css_xzik5yp59l;

export default class PlaylistContainer extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		this.playlist = new Playlist(this);
	}

	get cssText()
	{
		return css;
	}
}